const LocationPinSvg = ({
  height = 16,
  width = 16,
  viewBox = '0 0 16 16',
  className = '',
  color = '#D7D8DF',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
  className?: string;
  color?: string;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" className={className}>
      <path
        d="M13.3334 6.66732C13.3334 9.99598 9.64075 13.4627 8.40075 14.5333C8.28523 14.6202 8.14461 14.6672 8.00008 14.6672C7.85555 14.6672 7.71493 14.6202 7.59941 14.5333C6.35941 13.4627 2.66675 9.99598 2.66675 6.66732C2.66675 5.25283 3.22865 3.89628 4.22885 2.89608C5.22904 1.89589 6.58559 1.33398 8.00008 1.33398C9.41457 1.33398 10.7711 1.89589 11.7713 2.89608C12.7715 3.89628 13.3334 5.25283 13.3334 6.66732Z"
        stroke={color}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 8.66602C9.10457 8.66602 10 7.77059 10 6.66602C10 5.56145 9.10457 4.66602 8 4.66602C6.89543 4.66602 6 5.56145 6 6.66602C6 7.77059 6.89543 8.66602 8 8.66602Z"
        stroke={color}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LocationPinSvg;
